import './polyfill';
import { ZamponaElement } from './zampona-element';

customElements.define('zampona-element', ZamponaElement);
